// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 34408) return "static/chunks/6be3862c-f819e474ccca3396.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "5233653095359649" + ".js";
};